import { withInstall } from '@bigin/utils'
import NumericInput from './src/numeric-input.vue'

export const BNumericInput = withInstall(NumericInput)

export default BNumericInput
export * from './src/numeric-input'
